// components/MediaBlockEditor.tsx
import React, { useState, useEffect } from 'react';
import {Modal, Button, TextField, Box, Typography, IconButton} from '@mui/material';
import {
    getMediaBlocks,
    addMediaBlock,
    updateMediaBlock,
    deleteMediaBlock,
    uploadPhoto,
    deletePhoto
} from '../services/api';
import {MediaBlockModel, PhotoModel} from "../services/types";
import {Add} from "@mui/icons-material";
import Icon from "./Icon";
import ReactQuill from "react-quill-new";
import EditorToggle from "./EditorToggle";


interface MediaBlockEditorProps {
    quizId: string;
    section: number
    isBefore: boolean;
}
const modules = {
    toolbar: [
        [{ header: [1, 2, false] }],
        ['bold', 'italic', 'underline'],
        ['link', 'image']
    ]
};
const MediaBlockEditor: React.FC<MediaBlockEditorProps> = ({ quizId, section, isBefore }) => {
    const [mediaBlocks, setMediaBlocks] = useState<MediaBlockModel[]>([]);
    const [openModal, setOpenModal] = useState(false);
    const [modalType, setModalType] = useState('addBlock');
    const [newTitle, setNewTtitle] = useState<string>('');
    const [newDescription, setNewDescription] = useState<string>('');
    const [blockId, setBlockId] = useState('');
    const [content, setContent] = useState('');
    const [newPhoto, setNewPhoto] = useState<File | null>(null);
    const [photosPreview, setPhotosPreview] = useState<PhotoModel[]>([]);

    useEffect(() => {
        fetchMediaBlocks();
    }, []);

    const fetchMediaBlocks = async () => {
        try {
            // Реализуйте запрос для получения медиа-блоков
            const response = await getMediaBlocks(quizId, section, isBefore);
            setMediaBlocks(response.items);

        } catch (error) {
            console.error('Error fetching media blocks:', error);
        }
    };

    const handleAddBlock = async () => {
        try {
            await addMediaBlock({ quiz_id: quizId, section: section, title: newTitle, description: newDescription, is_before: isBefore });
            setNewTtitle('');
            setNewDescription('');
            setOpenModal(false);
            fetchMediaBlocks();
        } catch (error) {
            console.error('Error adding media block:', error);
        }
    };

    const handleEditBlock = async () => {
        try {
            await updateMediaBlock(blockId, { quiz_id: quizId, section: section, title: newTitle, description: newDescription, is_before: isBefore });
            setNewTtitle('');
            setNewDescription('');
            setOpenModal(false);
            fetchMediaBlocks();
        } catch (error) {
            console.error('Error editing media block:', error);
        }
    };

    const handleDescriptionChange = (value:string) => {
        setNewDescription(value);
    };
    const handleDeleteBlock = async (blockId: string) => {
        try {
            await deleteMediaBlock(blockId);
            fetchMediaBlocks();
        } catch (error) {
            console.error('Error deleting media block:', error);
        }
    };
    const handleDeletePhoto = async (photoId: string, index: number) => {
        try {
            await deletePhoto(photoId);
            const newPhotos = [...photosPreview];
            newPhotos.splice(index, 1);
            setPhotosPreview(newPhotos);
        } catch (error) {
            console.error('Error deleting media block:', error);
        }
    };
    const handlePhotoUpload = async () => {
        if (!newPhoto) return;

        try {
            const formData = new FormData();
            formData.append('file', newPhoto);
            const response = await uploadPhoto(blockId, formData);
            setPhotosPreview((prevPhotos) => [...prevPhotos, response]);
        } catch (error) {
            console.error('Error uploading photo:', error);
        }
    };
    return (
        <Box sx={{ mt: 2, p: 2, background: '#4978240f' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6">Медиа-блоки</Typography>
                <Button onClick={() => {
                    setModalType('addBlock');
                    setOpenModal(true);
                    setNewTtitle('');
                    setNewDescription('');
                }}>
                    <Add/> Добавить блок
                </Button>
            </Box>
            {mediaBlocks.map((block) => (
                <Box className='scenarioItem' key={block.id} sx={{ display: 'flex', alignItems: 'center', mt: 2, backgroundColor: '#fff' }}>
                    <Box sx={{ flexGrow: 1 }}>{block.title}</Box>
                    <Box>
                        <IconButton onClick={() => {
                            setModalType('editBlock');
                            setBlockId(block.id);
                            setNewTtitle(block.title);
                            setNewDescription(block.description);
                            setPhotosPreview(block.photos);
                            setOpenModal(true);
                        }}><Icon name="edit" /></IconButton>
                        <IconButton onClick={() => handleDeleteBlock(block.id)}><Icon name="remove" /></IconButton>
                    </Box>
                </Box>
            ))}
            <Modal open={openModal} onClose={() => setOpenModal(false)}>
                <Box sx={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', overflowY: 'scroll', height: '100vh' }}>
                    <Box sx={{ p: 4, bgcolor: 'white', margin: 'auto', width: 1000, borderRadius: 2 }}>
                        <Typography id="modal-modal-title" variant="h6" sx={{ mb: 2 }}>
                            {modalType === 'addBlock' ? 'Добавить блок' : 'Редактировать'}
                        </Typography>

                        <TextField
                            fullWidth
                            label="Название"
                            value={newTitle}
                            onChange={(e) => setNewTtitle(e.target.value)}
                            sx={{ mb: 2 }}
                        />

                        <EditorToggle
                            width="100%"
                            label="Описание"
                            initialValue={newDescription}
                            onChange={handleDescriptionChange}
                        />
                        {modalType === 'editBlock' && (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '6px', mt:2 }}>
                                {photosPreview.map((photo, index) => (
                                    <Box sx={{position: 'relative'}}>
                                        <img src={photo.image_url} alt="Photo" width={115} height={115} key={photo.id} style={{objectFit: 'cover'}}/>
                                        <IconButton onClick={() => handleDeletePhoto(photo.id, index)} style={{position: 'absolute', display: 'block', right: '0', top: '0'}}><Icon name="remove" /></IconButton>
                                    </Box>
                                ))}
                            </Box>
                        )}
                        {modalType === 'editBlock' && (
                            <input
                                type="file"
                                onChange={(e) => {
                                    setNewPhoto(e.target.files![0]);
                                }}

                            />
                        )}
                        {modalType === 'editBlock' && (
                            <Button onClick={handlePhotoUpload}>Загрузить фото</Button>
                        )}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
                            {modalType === 'addBlock' && (
                                <Button onClick={handleAddBlock}>Добавить блок</Button>
                            )}
                            {modalType === 'editBlock' && (
                                <Button onClick={handleEditBlock}>Сохранить изменения</Button>
                            )}
                            <Button onClick={() => setOpenModal(false)} sx={{ ml: 2 }}>
                                Отмена
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>
        </Box>
    );
};

export default MediaBlockEditor;
